// =============================================================================
// TOKENS DE COMPONENTES BÁSICOS - SISTEMA DE DISEÑO TADMIN
// =============================================================================
// Tokens para componentes básicos de UI: botones, inputs, cards

import colors from './colors.js';
import typography from './typography.js';
import spacing from './spacing.js';
import shadows from './shadows.js';
import borders from './borders.js';

// Desestructuración segura de typography
const typographyData = typography || {};
const fontFamily = typographyData.fontFamilies || {};
const fontSize = typographyData.fontSizes || {};
const fontWeight = typographyData.fontWeights || {};
const lineHeight = typographyData.lineHeights || {};

// =============================================================================
// TOKENS PARA BOTONES
// =============================================================================
export const buttonTokens = {
  // Tamaños
  sizes: {
    xs: {
      padding: '4px 8px',
      fontSize: fontSize.xs,
      lineHeight: lineHeight.tight,
      borderRadius: borders.radius.sm,
    },
    sm: {
      padding: '8px 12px',
      fontSize: fontSize.sm,
      lineHeight: lineHeight.tight,
      borderRadius: borders.radius.md,
    },
    md: {
      padding: '10px 16px',
      fontSize: fontSize.base,
      lineHeight: lineHeight.normal,
      borderRadius: borders.radius.md,
    },
    lg: {
      padding: '12px 24px',
      fontSize: fontSize.lg,
      lineHeight: lineHeight.normal,
      borderRadius: borders.radius.lg,
    },
    xl: {
      padding: '16px 32px',
      fontSize: fontSize.xl,
      lineHeight: lineHeight.normal,
      borderRadius: borders.radius.lg,
    },
  },
  
  // Variantes
  variants: {
    primary: {
      backgroundColor: colors.light.primary.main,
      color: colors.light.primary.contrast || colors.light.text.inverse,
      border: borders.component.button.primary,
      boxShadow: shadows.component.button.default,
      '&:hover': {
        backgroundColor: colors.light.primary.dark,
        boxShadow: shadows.component.button.hover,
      },
      '&:active': {
        backgroundColor: colors.light.primary.dark,
        boxShadow: shadows.component.button.active,
      },
      '&:focus': {
        boxShadow: shadows.component.button.focus,
      },
    },
    secondary: {
      backgroundColor: colors.light.secondary.main,
      color: colors.light.secondary.contrast || colors.light.text.inverse,
      border: borders.component.button.secondary,
      boxShadow: shadows.component.button.default,
    },
    outline: {
      backgroundColor: 'transparent',
      color: colors.light.primary.main,
      border: borders.component.button.outline,
      boxShadow: shadows.base.none,
    },
    ghost: {
      backgroundColor: 'transparent',
      color: colors.light.text.primary,
      border: borders.component.button.ghost,
      boxShadow: shadows.base.none,
    },
  },
};

// =============================================================================
// TOKENS PARA INPUTS
// =============================================================================
export const inputTokens = {
  // Tamaños
  sizes: {
    sm: {
      padding: '8px 12px',
      fontSize: fontSize.sm,
      lineHeight: lineHeight.normal,
      borderRadius: borders.radius.input,
    },
    md: {
      padding: '10px 16px',
      fontSize: fontSize.base,
      lineHeight: lineHeight.normal,
      borderRadius: borders.radius.input,
    },
    lg: {
      padding: '12px 20px',
      fontSize: fontSize.lg,
      lineHeight: lineHeight.normal,
      borderRadius: borders.radius.input,
    },
  },
  
  // Estados
  states: {
    default: {
      backgroundColor: colors.light.background.default,
      color: colors.light.text.primary,
      border: borders.component.input.default,
      boxShadow: shadows.component.input.default,
    },
    focus: {
      border: borders.component.input.focus,
      boxShadow: shadows.component.input.focus,
    },
    error: {
      border: borders.component.input.error,
      boxShadow: shadows.component.input.error,
    },
    success: {
      border: borders.component.input.success,
      boxShadow: shadows.component.input.success,
    },
  },
};

// =============================================================================
// TOKENS PARA CARDS
// =============================================================================
export const cardTokens = {
  // Variantes
  variants: {
    default: {
      backgroundColor: colors.light.surface.default,
      border: borders.component.card.default,
      borderRadius: borders.radius.card,
      boxShadow: shadows.component.card.default,
      padding: '16px',
    },
    elevated: {
      backgroundColor: colors.light.surface.elevated,
      border: borders.component.card.elevated,
      borderRadius: borders.radius.card,
      boxShadow: shadows.component.card.elevated,
      padding: '24px',
    },
    interactive: {
      backgroundColor: colors.light.surface.default,
      border: borders.component.card.interactive,
      borderRadius: borders.radius.card,
      boxShadow: shadows.component.card.default,
      padding: '16px',
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',
      '&:hover': {
        boxShadow: shadows.component.card.hover,
        transform: 'translateY(-2px)',
      },
    },
  },
};